/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : PageNotFound.jsx
 * description   : {{insert here}}
 * creation date : 16/03/2025
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Flex,
    Text,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
    toolKit,
} from '@/components/core';

import {
    ViewPortContainer,
} from '@/components/snippets/CustomDiv';

import {
    LinkButton,
} from '@/components/snippets/RouterLink';

import {
    route_list,
} from '@/utils/router/core';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function PageNotFound() {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <ViewPortContainer
                viewPort={toolKit.enums.window.viewPortTypes.FULL}
            >
                <Flex
                    alignItems='center'
                    direction='column'
                    gap={ctx.theme.tokens.space.zero}
                    paddingLeft={
                        ctx.api.utils.adaptiveOption(
                            ctx.theme.tokens.space.large,
                            ctx.theme.tokens.space.large,
                            ctx.theme.tokens.space.medium
                        )
                    }
                    paddingRight={
                        ctx.api.utils.adaptiveOption(
                            ctx.theme.tokens.space.large,
                            ctx.theme.tokens.space.large,
                            ctx.theme.tokens.space.medium
                        )
                    }
                    paddingTop={
                        ctx.api.utils.adaptiveOption(
                            ctx.theme.tokens.space.xxxl,
                            ctx.theme.tokens.space.xxxl,
                            ctx.theme.tokens.space.large
                        )
                    }
                    paddingBottom={
                        ctx.api.utils.adaptiveOption(
                            ctx.theme.tokens.space.xxxl,
                            ctx.theme.tokens.space.xxxl,
                            ctx.theme.tokens.space.xxxl
                        )
                    }
                    textAlign='center'
                >
                    <Text
                        fontSize={
                            ctx.api.utils.adaptiveOption(
                                '15rem',
                                '13rem',
                                '9rem'
                            )
                        }
                        fontFamily='Cera Pro'
                        fontWeight={ctx.theme.tokens.fontWeights.extrabold}
                        lineHeight={ctx.theme.tokens.lineHeights.small}
                    >
                        {/* TODO: Translate message */}
                        404
                    </Text>

                    <Text
                        fontSize={
                            ctx.api.utils.adaptiveOption(
                                ctx.theme.tokens.fontSizes.xxxl,
                                ctx.theme.tokens.fontSizes.xxl,
                                ctx.theme.tokens.fontSizes.large
                            )
                        }
                        fontFamily='Cera Pro'
                        fontWeight={ctx.theme.tokens.fontWeights.medium}
                        lineHeight={ctx.theme.tokens.lineHeights.small}
                    >
                        {/* TODO: Translate message */}
                        PAGE NOT FOUND
                    </Text>

                    <LinkButton
                        to={
                            toolKit.api.location.buildUrl(
                                route_list.HOME
                            )
                        }
                        fontWeight='normal'
                        size='small'
                        variation='link'
                        marginTop={ctx.theme.tokens.space.large}
                        className='custom-button-link'
                    >
                        {/* TODO: Translate message */}
                        Back to home page
                    </LinkButton>
                </Flex>
            </ViewPortContainer>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default PageNotFound;



// End of file
